(function () {
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    document.querySelectorAll('[data-vx-filter-group]').forEach(function (group) {
      var chips = group.querySelectorAll('[data-vx-filter]');
      var targetSel = group.getAttribute('data-vx-target');
      var items = targetSel ? document.querySelectorAll(targetSel) : [];

      chips.forEach(function (chip) {
        chip.addEventListener('click', function (event) {
          if (chip.tagName === 'BUTTON') event.preventDefault();
          var value = chip.getAttribute('data-vx-filter');
          chips.forEach(function (c) {
            c.classList.toggle('is-active', c === chip);
          });
          items.forEach(function (item) {
            var key = item.getAttribute('data-vx-key') || '';
            item.classList.toggle('is-hidden', value !== 'all' && key !== value);
          });
        });
      });
    });

    function syncLiveMeUp() {
      var slot = document.getElementById('livemeup-landingpage');
      var empty = document.querySelector('[data-vx-lmu-empty]');
      if (!slot) return;
      slot.style.display = '';
      slot.style.height = '';
      slot.style.minHeight = '';
      slot.style.overflow = '';
      var hasContent = slot.childElementCount > 0 || slot.querySelector('img, video, iframe, a, button, [class*="lmu"], [class*="Replay"]');
      if (empty) empty.hidden = !!hasContent;
    }
    syncLiveMeUp();
    window.setTimeout(syncLiveMeUp, 800);
    window.setTimeout(syncLiveMeUp, 2500);
    window.setTimeout(syncLiveMeUp, 6000);
  });
})();
